// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";
import SoftButton from "components/SoftComponents/SoftButton";
import { Link } from "react-router-dom";
import { useSoftUIController } from "hooks/context";

function NewAssignmentsCard({ bgColor = "white", assignment_count = null }) {

    const [controller] = useSoftUIController();
    const { deviceLayout } = controller;

    // ADJUST ASSIGNMENTS

    return (
        <SoftBox component={Link} to="/operations" state={{ filter: 'unresolved' }} height="100%" display="flex" flexDirection="column" justifyContent="space-between" variant="gradient" sx={({ palette, functions: { rgba } }) => ({ textDecoration: 'none', borderRadius: '16px', backgroundColor: rgba(palette[bgColor].main, 0.8) })}>
            <SoftBox height="100%" display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" px={2} py={1}>
                <SoftBox>
                    <SoftTypography variant={deviceLayout == 'mobile' ? "subtitle2" : "subtitle1"} fontWeight="medium" lineHeight={1.3}>
                        Outstanding Assignments
                    </SoftTypography>
                    <SoftTypography variant={deviceLayout == 'mobile' ? "mobileBody3" : "subtitle3"}>
                        That are currently unresolved.
                    </SoftTypography>
                </SoftBox>
                <SoftBox display="flex" alignItems="center" gap={{ xxs: 1, xl: 2 }}>
                    <SoftTypography fontWeight="bold" sx={{ fontSize: deviceLayout == 'mobile' ? '40px' : '50px', lineHeight: 1 }}>{assignment_count == null ? '-' : assignment_count}</SoftTypography>
                    <SoftButton variant="gradient" color="primary" circular state={{ filter: 'unresolved' }} sx={{ p: 1, borderRadius: '10px', display: 'flex', width: '40px !important', height: '40px !important', minWidth: '40px !important' }}>
                        <Icon>exit_to_app</Icon>
                    </SoftButton>
                </SoftBox>
            </SoftBox>

        </SoftBox>
    );
}

// Typechecking props for the NewAssignmentsCard
NewAssignmentsCard.propTypes = {
    bgColor: PropTypes.oneOf([
        "white",
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "error",
        "dark",
    ]),
    assignment_count: PropTypes.number,
};

export default NewAssignmentsCard;
